<template>
	<information-card
		title="Escoge tus factores"
		sub-title="Instructivo"
	>
		<div slot="content">
			<p class="textjustify">Los Factores de Valoración son los elementos comunes que permiten remunerar a las personas
				que ocupan los puestos de trabajo. Es comúnmente aceptado que los diferentes grados o niveles
				de “Responsabilidad” justifican el nivel de remuneración de un puesto respecto de otro.
				Lo mismo sucede con los demás factores como los niveles de exigencia de “Experiencia” o los
				requisitos de habilidades o riesgos inherentes a un puesto de trabajo.</p>
			<p class="textjustify">
			Puedes elegir los factores que califiquen al puesto para luego asignarle una puntuación según
			la complejidad o grado exigencia de ese factor en el puesto.</p>
			<p class="textjustify">Si necesitas más información puedes recurrir a tutoriales de nuestra web: www.praktiko.tech
			en la pestaña “Comunidad” PRAKTIKO subpestaña “Entrenamiento” o escribir un email a: info@praktiko.tech</p>
		</div>
		<div slot="footer" class="tw-text-center">
			<v-btn class="custom-button black" @click="back">Atrás</v-btn>
			<v-btn class="custom-button" color="primary" @click="next" :disabled="!nextIsEnabled">Siguiente</v-btn>
		</div>
	</information-card>
</template>

<script>
import InformationCard from '@/modules/shared/components/content/InformationCard';

export default {
	name: 'ValuationModelDescriptionNavigation',
	components: { InformationCard },
	props: ['nextIsEnabled', 'selectedFactors'],
	methods: {
		next() {
			this.goTo('job-supply-valuation-model-factors-weighting');
		},
		back() {
			this.goTo('job-evaluation-supplies');
		},
	},
};
</script>
<style scoped>
.textjustify {
text-align:justify;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-choice/ValuationModelDescriptionNavigation.vue